import React, { useEffect ,useState} from 'react'
import {Pagination as CustomePagination} from '@mui/material';
import {useSelector,useDispatch} from 'react-redux'
import './Pagination.css'
import Box from '@mui/material/Box';
import {ContainerPageNumber} from './StyledComponents/GridStyledComponent'
import {useTranslation} from "react-i18next";

export default function Pagination({count,page,showFirstButton,showLastButton,pageNumber,setpageNumber,totalPage}){
    const directions = useSelector(state => state.settingsData.directions)
    const SideMenuOpen = useSelector(state => state.settingsData.SideMenuOpen)
    const GridTheme = useSelector(state => state.settingsData.GridTheme)
    const [t, i18n] = useTranslation('common');


    const [WindowWidth,setWindowWidth]=useState(window.innerWidth)

    useEffect(()=>{
      window.addEventListener('resize',()=>{
        setWindowWidth(window.innerWidth)
      })
    },[])

  return (
    <div className="containerPagination">
        <Box   className={`pagination ${SideMenuOpen?'menuOpen':''}`} 
        sx={{
          backgroundColor:GridTheme?.primaryColor,
        }}>
            <CustomePagination
                className="PaginationHimSelf"
                color="primary"
                size={WindowWidth<=1000?'medium':WindowWidth<=991?'small':"large"}
                count={count}
                page={page}
                showFirstButton={showFirstButton}
                showLastButton={showLastButton}
                onChange={(e, p) => {
                    setpageNumber(p)
                }}
                sx={{
                  '& li button':{
                    color:GridTheme?.primaryColor,
                    backgroundColor:GridTheme?.oppositePrimaryColor,
                  },
                  '& li button:hover':{
                    color:GridTheme?.primaryColor,
                    backgroundColor:GridTheme?.oppositePrimaryColor,

                  },
                  '& MuiPaginationItem-textPrimary':{
                    backgroundColor:GridTheme?.oppositePrimaryColor,
                  },
                  '& .muiltr-1to7aaw-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected':{
                    color:GridTheme?.primaryColor,
                    backgroundColor:GridTheme?.oppositePrimaryColor,
                  }

                }}
            />
            <ContainerPageNumber className="containerPageNumber" color={GridTheme?.disabledGlobalText?GridTheme?.gloablTextColor:GridTheme.oppositePrimaryColor} bgColor={GridTheme?.primaryColor}>
                <input type="number" value={pageNumber} className="pageNumber" min={totalPage>0?1:0} max={totalPage} onChange={(e)=>{
                  setpageNumber(parseInt(e.target.value))
                }} />
                <span>{t('GLOBAL.PAGINATION_PAGE_NUMBER')}</span>
            </ContainerPageNumber>
        </Box>
   </div>
  )
}
